// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3zEgg","buttons":"PendingPaymentAlert_buttons__1P-qa"};